class Modal extends HTMLElement {
  constructor() {
    super(...arguments);
    this.onOverlayClick = this.overlayClickHandler.bind(this);
  }
  generateStyles() {
    const stylesEl = document.createElement('style');
    stylesEl.innerHTML = `
      hc-modal {
          display: flex;
          align-items: center;
          justify-content: center;
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          visibility: hidden;
          opacity: 0;
          background-color: rgba(0, 0, 0, .7);
          z-index: 100;
          transition: all 0.2s;
      }

      hc-modal.modal-open {
          visibility: visible;
          opacity: 1;
      }

      hc-modal .popup {
          background-color: #fff;
          box-shadow: 0 2rem 4rem rgba(255,255,255, 0.15);
          width: 30%;
          height: 70%;
          border-radius: 0.4rem;
          z-index: 110;
      }

      hc-modal .close-modal-button {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 1.4rem;
        right: 2rem;
        color: #fff;
      }
      
      hc-modal .close-modal-button svg {
        fill: #fff;
      }
  `;
    return stylesEl;
  }
  attachStyles() {
    const stylesEl = this.generateStyles();
    this.insertAdjacentElement('afterbegin', stylesEl);
  }
  createCloseButtonElement() {
    const closeButton = document.createElement('button');
    closeButton.classList.add('close-modal-button');
    closeButton.type = 'button';
    closeButton.innerHTML = `
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#000000" viewBox="0 0 256 256">
    <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path>
  </svg>
  `;
    return closeButton;
  }
  insertOverlayCloseButton() {
    const closeButton = this.createCloseButtonElement();
    this.appendChild(closeButton);
  }
  connectedCallback() {
    this.attachStyles();
    this.insertOverlayCloseButton();
    this.__bindOverlayClickHandler();
  }
  disconnectedCallback() {
    this.__removeOverlayClickHandler();
  }
  closeModal() {
    this.classList.remove('modal-open');
    this.addEventListener('transitionend', () => {
      this.remove();
    });
  }
  isPopupClicked(clickedEl) {
    return Boolean(clickedEl.closest('.popup'));
  }
  overlayClickHandler(event) {
    const clicked = event.target;
    if (this.isPopupClicked(clicked)) return;
    this.closeModal();
  }
  __bindOverlayClickHandler() {
    this.addEventListener('click', this.onOverlayClick);
  }
  __removeOverlayClickHandler() {
    this.removeEventListener('click', this.onOverlayClick);
  }
}
customElements.define('hc-modal', Modal);
